import React, { useState } from 'react'
import Select from "react-select"

import { usePet } from '../../modules'

import Modal from "../reusable/modal"

const WalkIn = ({ toggle, visible, onPerform }) => {
    const [name, setName] = useState()
    const [age, setAge] = useState()
    const [gender, setGender] = useState()

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            case 'age':
                setAge(e.target.value)
                break

            default:
                break
        }
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Walk In patient has been registered', ops('success'))
    }

    const [{ loading }, newWalkIn] = usePet('newWalkIn', { 
        name, 
        gender: gender?.value, 
        age,
        bill: true
    }, { notify: true, callback: onComplete, manual: true })

    return (
        <Modal
            w={ 450 }
            title="New Walk-In"
            toggle={toggle}
            visible={visible}>
            <div className="w-full bg-white">
                <div className="w-full px-3 mb-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Name
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-name"
                        type="text"
                        name="name"
                        value={name}
                        onChange={modify}
                        placeholder="Wilson Kamau" />
                </div>
                <div className="w-full px-3 mb-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-gender">
                        Gender
                    </label>
                    <Select
                        value={gender}
                        onChange={setGender}
                        options={['Male', 'Female'].map(item => ({ label: item, value: item }))}
                        placeholder="Select Gender" />
                </div>
                <div className="w-full px-3 my-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-email">
                        Age
                    </label>
                    <input
                        onChange={modify}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-first-age"
                        type="number"
                        value={age}
                        name="age"
                        placeholder="Age in years" />
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={ loading } onClick={newWalkIn} type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Proceed</button>
            </div>
        </Modal>
    )
}

export default WalkIn